"use client";

import { useEffect, useMemo } from "react";
import compact from "lodash/compact";

import { MhcAttribution, MhcAttributionFragment } from "graphqlApi/types";

import useRouterPath from "common/util/hooks/usePathWithParamKeys";

import { useAttributionsStore } from "common/state/useAttributionsStore";
import DownloadDataButton, {
  DownloadDataButtonFallback
} from "common/components/DownloadData/DownloadDataButton";

export const PageAttributionsUpdater = ({
  baseKey,
  attributions
}: {
  baseKey: string;
  attributions: MhcAttribution[];
}) => {
  // This is a simple empty component which is a clint component that allows for easy
  // updating of the attributions of a page from a server component.
  const { setAttributions } = useAttributionsStore((s) => s);
  useEffect(() => {
    setAttributions(baseKey, attributions);
  }, [baseKey, attributions, setAttributions]);
  return <></>;
};

const DownloadDataForPage = ({ baseKey = "" }: { baseKey?: string }) => {
  const {
    params: { subTopicId = "" }
  } = useRouterPath();
  const key = useMemo(() => compact([baseKey, subTopicId]).join("-"), [baseKey, subTopicId]);

  const { getAttributionsByKey } = useAttributionsStore((s) => s);
  const attributions = getAttributionsByKey(key);

  if (!attributions?.length) {
    return <DownloadDataButtonFallback />;
  }

  return <DownloadDataButton attributions={attributions as MhcAttributionFragment[]} />;
};

export default DownloadDataForPage;
